/** Where the survey grant pages live. */
export const surveyGrantsPath = '/entitlements/survey-grants'
export const grantSurveyPath = `${surveyGrantsPath}/new`

/** The permissions the survey grant screens show or hide their actions by. */
export const readSurveyGrantsPermission = 'entitlements.survey-grants.read'
export const writeSurveyGrantsPermission = 'entitlements.survey-grants.write'
export const deleteSurveyGrantsPermission = 'entitlements.survey-grants.delete'

/** The API's survey grant endpoints. */
export const surveyGrantsApi = '/entitlements/v1/survey-grants'
export const mySurveyGrantsApi = '/entitlements/v1/me/survey-grants'
/** The surveys the caller may give, for Grant Survey's chooser. */
export const grantableSurveysApi = `${surveyGrantsApi}/surveys`

export function surveyGrantApi(id: string): string {
  return `${surveyGrantsApi}/${encodeURIComponent(id)}`
}
